import { Fragment, memo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setAiInfo } from "../../../../Redux/AiType/AiTypeSlice";
import { toast } from 'react-toastify';
import Translate from "../../../Multilanguage/Translate";
import { LazyLoadImage } from "react-lazy-load-image-component";

const TopTenCard = memo((props) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const dispatch = useDispatch();
  const thumbnailClass = props.thumbnail === "PORTRAIT" ? "top-ten-portrait" : "top-ten-landscape";
  const showName = props?.state?.videoDetails?.show_name;
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const ai_type = props?.state?.videoDetails?.ai_type;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const pubid = projectInfo?.projectConfig?.pubid;
  const isFreeMovies = Number(pubid) === 50188;
  const topTenNumberClass = pubid === 50147 ? "top-ten-numbers top-ten-numbers-newblock" : template === 'TEMPLATE_9' || template === 'TEMPLATE_12' || template === 'TEMPLATE_10' || theme === 'LIGHT' ? "top-ten-numbers top-ten-numbers-extra" : "top-ten-numbers";

  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const resolvedImagePath = template === 'TEMPLATE_12' && isMobile && props.portraitImagePath
    ? props.portraitImagePath
    : props.imagePath;

  const handleCardClick = (e) => {
    const userId = localStorage.getItem('userId');
    if (template === 'TEMPLATE_12' && !userId && props.isRegisterPage) {
      e.preventDefault && e.preventDefault();
      toast.info(<Translate textKey={'sign_in_required'} />);
      window.dispatchEvent(new Event('kids-register-focus-email'));
      return;
    }
    dispatch(setAiInfo(ai_type ?? null));
  };

  return (
    <Fragment>
      <div className={`iq-top-ten-block ${thumbnailClass} ${template === 'TEMPLATE_12' ? 'kids' : ''}`}>
        <div className={`block-image position-relative ${thumbnailClass}`}>
          <div className="img-box">
            <div className={`cardContainer ${template === 'TEMPLATE_12' ? 'kids' : ''}`}>
              <Link className="overly-images" to={props.link} state={props.state} onClick={(e) => handleCardClick(e)}>
                <LazyLoadImage
                  src={resolvedImagePath}
                  alt="movie-card"
                  className="img-fluid object-cover"
                  threshold={0}
                  visibleByDefault={props.cardIndex < props.initialVisibleCount}
                  loading={props.cardIndex < props.initialVisibleCount ? "eager" : "lazy"}
                  fetchPriority={props.cardIndex < props.initialVisibleCount ? "high" : "auto"}
                />
              </Link>
              <span className={`${topTenNumberClass} ${[50158, 50157, 50167].includes(pubid) ? "top-ten-numbers-small" : ""} ${isFreeMovies ? "top-ten-numbers-free-movies" : ""} texture-text`}>{props.countValue}</span>
            </div>
          </div>
          <div className={`metaData ${isFreeMovies ? 'freeMoviesMetaData' : ''}`}>
            <h1 className="title" title={showName}>
              {showName}
            </h1>
          </div>

        </div>
      </div>
    </Fragment>
  );
});

TopTenCard.displayName = "TopTenCard";
export default TopTenCard;
